import series from '@/application/lib/series'

export default {
    data() {
        return {
            loadingSerial: false,
            nextSerie: null,
        }
    },
    methods: {
        //! deprecated
        // async loadSerialNumber(name) {
        //     try {
        //         if (!this.loadingSerial) {
        //             this.loadingSerial = true

        //             const serie = await series.getSerialNumber(name)

        //             if (serie) {
        //                 this.fields.serie_r = serie.data
        //                 this.fields.serie = serie.value
        //                 this.nextSerie = serie.value
        //             } else {
        //                 this.fields.serie = ''
        //             }

        //             this.loadingSerial = false
        //         }
        //     } catch (error) {
        //         console.error(error)
        //         this.loadingSerial = false
        //     }
        // },

        loadSerialNumber(name) {
            return new Promise(async (resolve, reject) => {
                try {
                    if (!this.loadingSerial) {
                        this.loadingSerial = true

                        const serie = await series.getSerialNumber(name)

                        if (serie) {
                            this.fields.serie_r = serie.data
                            this.fields.serie = serie.value
                            this.nextSerie = serie.value
                            resolve(serie)
                        } else {
                            this.fields.serie = ''
                            reject(new Error('Serie no encontrada')) 
                        }

                        this.loadingSerial = false
                    }
                } catch (error) {
                    console.error(error)
                    this.loadingSerial = false
                    reject(error)
                }
            })
        },

        unlinkSerie() {
            this.fields.serie_r = null
        },

        async loadSerialNamesToSelect(excludes = []) {
            const response = await series.getAllSerialNames()
            if (response) {
                if (excludes.length > 0) {
                    this.seriesNames = response.filter((item) => {
                        return !excludes.includes(item)
                    }).map((item) => {
                        return {
                            key: item,
                            value: item,
                        }
                    })
                    return
                }
                this.seriesNames = response.map((item) => {
                    return {
                        key: item,
                        value: item,
                    }
                })
            }
        }
    },
}
